var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-tr-box",class:[{ 'position-inherit': _vm.elementTopPosition ? false : true }],style:('top:' +
      _vm.elementTopPosition +
      ';left:' +
      _vm.elementLeftPosition +
      ';width:' +
      _vm.elementWidth +
      ';height:' +
      _vm.elementHeight +
      ';font-size:' +
      _vm.fontSize)},_vm._l((_vm.items),function(item,index){return _c('div',{key:'item_' + index,staticClass:"box-item",style:(_vm.getItemStyle(_vm.config))},[_c('span',{staticClass:"item-text",domProps:{"innerHTML":_vm._s(item)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }